import { useState } from 'react';

const useAppliedFilter = () => {
  const INIT_FILTER = {
    client: [],
    expedition: [],
    paymentMode: [],
    city: [],
    zone: [],
    commercial: [],
    sort: {},
    deposit: '',
    numCommande: '',
    numExpedition: '',
    type: null,
    controlled: null,
    startDate: null,
    endDate: null,
  };
  const [values, setValues] = useState(INIT_FILTER);
  const [appliedFilter, setAppliedFilter] = useState(INIT_FILTER);

  const handleRefresh = () => {
    setValues(INIT_FILTER);
    setAppliedFilter(INIT_FILTER);
  };

  const onHandleSubmitFilters = () => {
    setAppliedFilter(values);
  };
  return {
    handleRefresh,
    values,
    setValues,
    appliedFilter,
    onHandleSubmitFilters,
  };
};

export default useAppliedFilter;
